'use strict';
import angular from 'angular';
import ExpressCheckoutController from './express-checkout.controller';
import CartService from '../../app/cart/cart.service';
import CreditCardService from '../credit-card-list/credit-card.service';
import SettingsService from '../../app/account/settings/settings.service';
import AddressService from '../forms/account/address/address.service';
import AddressListService from '../shipping-address-list/shipping-address-list.service';
export default angular.module('eeComUiApp.expressCheckout', [])
    .service('CartService', CartService)
    .service('CreditCardService', CreditCardService)
    .service('AddressService', AddressService)
    .service('AddressListService', AddressListService)
    .service('SettingsService', SettingsService)
    .component('expressCheckout', {
    template: require('./express-checkout.html'),
    controller: ExpressCheckoutController
})
    .name;
//# sourceMappingURL=index.js.map